import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UsersService } from '../services/users/users.service';
import { KeycloakService } from '../services/keycloak/keycloak.service';

/**
 * Adds an authorization header to ENT API requests.
 * @param req
 * @param next
 * @returns
 */
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // Whitelist some anonymous backend queries
  if (req.url.startsWith(environment.apiUrl)) {
    if (
      req.url.indexOf('api/graph/list/items/maintenance') > 0 ||
      req.url.indexOf('api/support/createticket') > 0 ||
      req.url.indexOf('api/users/password/recovery') > 0 ||
      req.url.indexOf('api/users/password/reset') > 0 ||
      req.url.indexOf('api/users/password/request') > 0 ||
      req.url.indexOf('api/users/start') > 0
    ) {
      return next(req);
    }
  }

  const userService = inject(UsersService);

  // ICT-VS Token for user activation
  if (req.url.indexOf('api/users/activate') > 0) {
    const currentUser = userService.currentUserValue;
    if (currentUser && currentUser.token) {
      const newReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          `Bearer ${currentUser.token}`
        ),
      });
      return next(newReq);
    }
  }

  // Keycloak token for everything else
  const keycloakService = inject(KeycloakService);
  if (keycloakService.keycloak.authenticated) {
    const newReq = req.clone({
      headers: req.headers.set(
        'Authorization',
        `Bearer ${keycloakService.keycloak.token}`
      ),
    });
    return next(newReq);
  }

  return next(req);
};
